if (typeof customElements.get('scroll-observer') == 'undefined') {
	class ScrollObserver extends HTMLElement {
		constructor() {
			super();
            this.videoPlayer = this.querySelector('.video-player');

			this.init();
		}

		init() {
			const intersectionObserver = new IntersectionObserver(
				(entries, observer) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							this.videoPlayer.play();
							observer.unobserve(this);
						}
					});
				},
				{ threshold: 0.5 }
			);

			intersectionObserver.observe(this);
		}
	}

	if (typeof customElements.get('scroll-observer') == 'undefined') {
		customElements.define('scroll-observer', ScrollObserver);
	}
}
